export default __webpack_public_path__ + "img/CaikumaElated.8f7af860.webp";